import React, { Fragment } from 'react';
import NavbarS3 from '../../components/NavbarS3/NavbarS3';
import PageTitle from '../../components/pagetitle/PageTitle'
import Contactpage from '../../components/Contactpage/Contactpage';
import Footer from '../../components/footer/Footer';
import Scrollbar from '../../components/scrollbar/scrollbar';
import Logo from '../../images/logo2.svg';
import MessengerChatButton from '../../components/Messenger/ChatSection';
import { useTranslation } from 'react-i18next';


const ContactPage = () => {
    const { t } = useTranslation();
    return (
        <Fragment>
            <NavbarS3 hclass={'wpo-site-header wpo-header-style-2'} Logo={Logo} />
            <PageTitle pageTitle={t('contactus.title')} pagesub={t('contact')} />
            <Contactpage />
            <Footer hclass={'wpo-site-footer'} />
            <Scrollbar />
            <MessengerChatButton />
        </Fragment>
    )
};
export default ContactPage;





